import { Pipe, PipeTransform } from '@angular/core';
import Moment from 'moment';
import { TranslateService } from '../translate/translate.service';

@Pipe({
    name: 'translateUTCDate',
    pure: false,
    standalone: false
})
export class TranslateUTCDatePipe implements PipeTransform {
	constructor(private _translate: TranslateService) {}

	transform(UTCdate: Date, format: string) {
		if (!UTCdate || !format) {
			return;
		}
		return Moment.utc(UTCdate).format(this._translate.instant(format));
	}
}
